function getFirstElementFromArray(array) {
    if (Array.isArray(array) && array.length > 0) {
        return array[0];
    } else return null;
}

export default getFirstElementFromArray;
